import { Component, OnInit } from '@angular/core';
import { IpClientService } from '@ats/ip/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'ip-client-required-selector',
    templateUrl: './client-required-selector.component.html',
    styleUrls: ['./client-required-selector.component.scss'],
    standalone: false
})
export class IpClientRequiredSelectorComponent implements OnInit {
	clients$: Observable<string[]>;

	constructor(private clients: IpClientService) {}

	ngOnInit() {
		this.clients$ = this.clients.clients$;
	}

	selectClient(id: string | null) {
		this.clients.selectClient(id);
	}
}
